import React, { useEffect, useRef, useState } from 'react'
import Preview from '../Preview'

// A preview that only draws once it's near the screen, so a panel of thirty
// designs opens instantly on a phone
const LazyPreview = ({ post, theme, format, rootMargin = '300px' }) => {
  const ref = useRef(null)
  const [seen, setSeen] = useState(typeof IntersectionObserver === 'undefined')
  useEffect(() => {
    if (seen || !ref.current) return undefined
    const io = new IntersectionObserver((entries) => {
      if (entries.some(e => e.isIntersecting)) { setSeen(true); io.disconnect() }
    }, { rootMargin })
    io.observe(ref.current)
    return () => io.disconnect()
  }, [seen, rootMargin])
  return (
    <span ref={ref} className={`sx-lazy${seen ? ' is-seen' : ''}`}>
      {seen ? <Preview post={post} theme={theme} format={format} /> : <span className="sx-preview sx-lazy-hold" />}
    </span>
  )
}

export default LazyPreview
